<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="isMainLayoutRoute" key="main-layout"></router-view>
    </keep-alive>
    <router-view v-if="!isMainLayoutRoute"></router-view>
  </div>
</template>

<script>
import {applyLatestLanguage} from '@/lang'
import {syncRouteTitles} from '@/utils/settingRouteLang'

export default {
  name: 'App',
  computed: {
    isMainLayoutRoute() {
      return this.$route.matched.some(item => item.meta && item.meta.keepRootLayout)
    }
  },
  created() {
    // 其他页签通过 storage 事件实时同步语言。
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange(event) {
      if (event.key === 'admin-userId' && !event.newValue) {
        // 其他页签退出登录后，直接切换到登录页，不刷新整个页面。
        if (this.$route.path !== '/login') {
          this.$router.replace('/login').catch(() => {})
        }
        return
      }

      if (event.key === 'language-admin') {
        const result = applyLatestLanguage()
        if (result.changed) syncRouteTitles(result.previousLanguage, result.language)
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue